
export class UltraContentEditableFilter {
    public static getContentEditableFilter(): (e: HTMLElement) => boolean {
        return (e: HTMLElement): boolean => !!e.closest('.document-editing');
    }
}
